import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  styled,
  Typography,
} from "@mui/material";
import type { ReactNode } from "react";

import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import { UnstyledLink } from "Shared/Routing/UnstyledLink";

const StyledLink = styled(UnstyledLink)`
  width: 100%;
  max-width: 100%;
  display: block;
`;

const StyledListItem = styled(ListItem, {
  shouldForwardProp: (prop) => prop !== "$isActive",
})<{ $isActive: boolean }>`
  padding: 0;
  overflow: hidden;
  margin-bottom: ${(props) => props.theme.spacing(Spacing.S)};
  height: 32px;

  &:hover {
    .MuiListItemButton-root {
      background: ${(props) =>
        props.$isActive
          ? props.theme.palette.background.paper
          : `${props.theme.palette.primary.main}20`};
    }
  }

  .MuiListItemButton-root {
    border-radius: ${Radius.M};
    padding: ${(props) => props.theme.spacing(Spacing.S, Spacing.S)};
    transition: all 0.2s ease-in-out;
    background: ${(props) =>
      props.$isActive ? props.theme.palette.background.paper : "transparent"};
    overflow: hidden;
    height: 32px;
    min-height: 32px;

    &:hover {
      background: ${(props) =>
        props.$isActive
          ? props.theme.palette.background.paper
          : `${props.theme.palette.primary.main}20`};
    }
  }

  .MuiTypography-root {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${(props) =>
      props.$isActive
        ? props.theme.palette.common.white
        : props.theme.colors.textLight} !important;
  }

  .MuiListItemIcon-root {
    color: ${(props) =>
      props.$isActive
        ? props.theme.palette.common.white
        : props.theme.colors.textLight} !important;
  }
`;

type Props = {
  text: string;
  icon: ReactNode;
  to: string;
  isCollapsed: boolean;
};

export const SidebarMenuItem = ({
  text,
  icon,
  to,
  isCollapsed,
}: Props): React.ReactNode => {
  // const location = useLocation();
  const isActive = location.pathname === to;

  return (
    <StyledLink to={to}>
      <StyledListItem disablePadding $isActive={isActive}>
        <ListItemButton
          sx={{
            justifyContent: isCollapsed ? "center" : "flex-start",
            width: "100%",
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: isCollapsed ? 0 : 56,
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            {icon}
          </ListItemIcon>
          {!isCollapsed && (
            <ListItemText
              primary={
                <Typography variant="body1" fontWeight={500}>
                  {text}
                </Typography>
              }
              sx={{ overflow: "hidden", flex: 1 }}
            />
          )}
        </ListItemButton>
      </StyledListItem>
    </StyledLink>
  );
};
